import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

/** ימי שבוע קצרים — א׳ = יום ראשון (כמו ב־dayjs .day()). */
const HEBREW_DOW = ["א׳", "ב׳", "ג׳", "ד׳", "ה׳", "ו׳", "ש׳"];

/**
 * @param {string|undefined|null} iso — YYYY-MM-DD או מתחיל בכך
 * @returns {string|null}
 */
export function formatIsoDateWithHebrewWeekday(iso) {
  if (typeof iso !== "string" || iso.length < 10) return null;
  const d = dayjs.utc(iso.slice(0, 10));
  if (!d.isValid()) return null;
  const dow = HEBREW_DOW[d.day()];
  return `${dow} ${d.format("DD/MM/YYYY")}`;
}

/**
 * שורת לינה לכרטיס צ'אט: יום+תאריך יציאה → יום+תאריך חזרה · לילות
 * מבוסס על שדות הכרטיס בלבד (לא טווח כללי מהשיחה).
 * @param {Record<string, unknown>} card
 * @returns {string|null}
 */
export function formatChatCardStayLineHe(card) {
  const dep = card?.departure_date;
  const ret = card?.return_date;
  const nights = card?.nights_count;
  if (typeof dep !== "string" || typeof ret !== "string") return null;
  const a = formatIsoDateWithHebrewWeekday(dep);
  const b = formatIsoDateWithHebrewWeekday(ret);
  if (!a || !b) return null;
  const n =
    nights != null && !Number.isNaN(Number(nights)) && Number(nights) > 0
      ? ` · ${Number(nights)} לילות`
      : "";
  return `${a} → ${b}${n}`;
}
